import { render } from "./TasksCalendarView.vue?vue&type=template&id=2dfe195e&scoped=true&ts=true&lang=pug"
import script from "./TasksCalendarView.vue?vue&type=script&lang=ts"
export * from "./TasksCalendarView.vue?vue&type=script&lang=ts"

import "./TasksCalendarView.vue?vue&type=style&index=0&id=2dfe195e&scoped=true&lang=scss"
import "./TasksCalendarView.vue?vue&type=style&index=1&id=2dfe195e&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfe195e"]])

export default __exports__